
define(
	'Tavano.TTFormCoa.CoaForm'
,   [
		'Tavano.TTFormCoa.CoaForm.View'
	]
,   function (
		CoaFormView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp(container) {
				var PageType = container.getComponent('PageType');

				PageType.registerPageType({
					name: 'coaForm',
					routes: ['coaform'],
					view: CoaFormView,
					defaultTemplate: {
						name: 'tavano_ttcoaform_coaform.tpl',
						displayName: 'CoA Form'
					}
				});

			}
	};
});
